import { combineReducers } from 'redux';
import { createReducer } from '@mews/framework';
import { SERVICE_STATISTICS_FETCH_SUCCEEDED, SERVICE_STATISTICS_RESET } from './actions/serviceStatistics';
import { ORDER_STATISTICS_FETCH_SUCCEEDED, ORDER_STATISTICS_RESET } from './actions/orderStatistics';
import { TASK_STATISTICS_FETCH_SUCCEEDED } from './actions/tasks';
import { OCCUPANCY_STATISTICS_FETCH_SUCCEEDED, OCCUPANCY_STATISTICS_RESET } from './actions/occupancyStatistics';

const tasksStatistics = createReducer(
    { isLoaded: false },
    {
        // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
        [TASK_STATISTICS_FETCH_SUCCEEDED]: (state, payload) => ({
            isLoaded: true,
            ...payload,
        }),
    }
);

const serviceStatisticsState = { isLoaded: false };
const serviceStatistics = createReducer(serviceStatisticsState, {
    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [SERVICE_STATISTICS_FETCH_SUCCEEDED]: (state, payload) => ({
        ...state,
        isLoaded: true,
        ...payload,
    }),
    [SERVICE_STATISTICS_RESET]: () => serviceStatisticsState,
});

const orderStatisticsInitialState = { isLoaded: false };
const orderStatistics = createReducer(orderStatisticsInitialState, {
    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [ORDER_STATISTICS_FETCH_SUCCEEDED]: (state, payload) => ({
        ...state,
        isLoaded: true,
        ...payload,
    }),
    [ORDER_STATISTICS_RESET]: () => orderStatisticsInitialState,
});

const occupancyStatisticsInitialState = { isLoaded: false };
const occupancyStatistics = createReducer(occupancyStatisticsInitialState, {
    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [OCCUPANCY_STATISTICS_FETCH_SUCCEEDED]: (state, payload) => ({
        ...state,
        ...payload,
        isLoaded: true,
    }),
    [OCCUPANCY_STATISTICS_RESET]: () => occupancyStatisticsInitialState,
});

export default combineReducers({
    orderStatistics,
    serviceStatistics,
    tasksStatistics,
    occupancyStatistics,
});
